module.exports = __webpack_public_path__ + "static/img/No1.7179d51f.svg";